import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { InputText, Dialog, Toast } from "primereact";
import ReactGA from "react-ga4";

import "../../assets/css/badge.css";

class ListaUtenti extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        icon: "pi-eye",
        label: "Visualizza",
        action: (id) => {
          this.vai(id, "V");
          console.log("Vedi");
        },
      },
      {
        icon: "pi-pencil",
        label: "Modifica",
        action: (id) => {
          this.vai(id, "U");
          console.log("Edit");
        },
      },
      {
        icon: "pi-trash",
        label: "Elimina",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete");
        },
      },
    ];

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));

    this.state = {
      xcarica: "sezione",
      utenti: [],
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
    };
    this.onPage = this.onPage.bind(this);

    this.ruoloid = JSON.parse(sessionStorage.getItem("ruoloid"));
  }
  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&utenteid=" + this.utente.id;
    axios
      .get(Costanti.UrlCallApi + "utente/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        this.setState({ utenti: res.data.lista1, totalRecords: res.data.conta1, loading: false });
      })
      .catch((error) => {
        alert(error);
      });
  }

  componentDidMount() {
    //.send({ hitType: "pageview", page: this.props.location.pathname });
    this.caricaDati(1, this.state.pageSize);
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  vai(id, tipo) {
    if (this.ruoloid == 4) {
      if (tipo === "V") this.props.history.push("/utente/" + id + "/" + tipo);
    } else {
      this.props.history.push("/utente/" + id + "/" + tipo);
    }
  }

  mailAttivazione(dati) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };

    axios
      .get(Costanti.UrlCallApi + "utente/attivazione/" + dati, config)
      .then(() => {
        this.showMessage("success", "Mail Inviata", "");
        this.caricaDati(1, this.state.pageSize);
      })
      .catch((error) => {
        this.showMessage("error", "Errore invio mail", error.message);
      });
  }
  setPDF(_value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/utenti/" + this.utente.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <DataTable
          value={this.state.utenti}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Utenti</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />

              <Button
                label="Esporta in Pdf"
                onClick={() => this.setPDF(true)}
                icon="pi pi-file-pdf"
                className="p-button-rounded p-button-danger "
              />
              {this.ruoloid <= 3 ? (
                <Button
                  label="Aggiungi"
                  onClick={() => this.vai(0, "A")}
                  icon="pi pi-plus"
                  className="p-button-rounded p-button-primary "
                />
              ) : (
                ""
              )}
            </div>
          }
          responsiveLayout="stack"
        >
          <Column field="photoUrl" body={(item) => <img src={item.photoUrl} alt="" />} />
          <Column field="nome" header="Nome" body={(item) => item.cognome + " " + item.nome} />
          <Column field="email" header="Email" body={(item) => <a href={`mailto:${item.email}`}>{item.email}</a>} />
          <Column
            header=""
            body={(item) =>
              item.status == "A" ? (
                <Button
                  label="Invia Mail Attivazione"
                  className="p-button-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.mailAttivazione(item.id);
                  }}
                />
              ) : (
                ""
              )
            }
          />
          <Column field="attivita" header="Ultima attivita" />
          {this.ruoloid === 1 ? <Column field="aziendaid" header="ID AZIENDA" /> : <Column header="" />}

          <Column
            field="permission"
            header="Admin"
            body={(item) => <Checkbox disabled checked={item.ruoloid == 3} className="mr-4" />}
          ></Column>
          <Column
            field="azoni"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {item.azioni.map((action) => (
                  <Button
                    key={action.label}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>
      </div>
    );
  }
}

export default ListaUtenti;
